module.exports = __webpack_public_path__ + "media/src/assets/icons/podinbox_logo_wide-e094d34f35a2dc4d39985887353151d1.png";